import React from 'react'

import { Icon } from '../../../../components/icons'
import { Column } from '../../../../components/layouts/columns'
import { Button } from '../../../../components/ui/button'
import { Table } from '../../../../components/ui/table'
import { Input } from '../../../../components/ui/input'
import { Page } from '../../../../components/layouts/page'
import useAdminReasons from './hooks/useAdminReasons'
import { PathDoc } from '../../../../router/docs'

export const AdminReasons = () => {
  const {
    search,
    setSearch,
    loading,
    dataContextFiltered,
    formContext,
    addReason,
    setFormContext,
    FetchGetData,
    handleDeleteReason,
  } = useAdminReasons()
  return (
    <>
      <Page.Root className="is-fullwidth">
        <Column.Root className="mt-6 pt-5">
          <Column.Content>
            <p className="subtitle is-size-3">Motivos</p>
          </Column.Content>
          <Column.Content className="has-text-right">
            <Button.Root align="right">
              <Button.Content>
                <Button.A className={'mr-4'} link={PathDoc.ReasonsCreate} openNew color="is-light" loading={loading}>
                  Tutorial
                </Button.A>
                <Button.Bt
                  color="is-dark"
                  colorText="has-text-white"
                  action={() => {
                    FetchGetData()
                  }}
                  loading={loading}
                >
                  <Icon size={15}>sync</Icon>
                </Button.Bt>
              </Button.Content>
              <Button.Content>
                <Button.Bt
                  className=""
                  color="is-success"
                  colorText="has-text-white"
                  action={() => {
                    setFormContext((prev) => ({
                      ...prev,
                      hasNewReason: prev?.hasNewReason ? !prev?.hasNewReason : true,
                    }))
                  }}
                  loading={loading}
                >
                  +
                </Button.Bt>
              </Button.Content>
            </Button.Root>
          </Column.Content>
        </Column.Root>

        {formContext.hasNewReason && (
          <Column.Root className="box">
            <Column.Content>
              <Input.Root>
                <Input.Contents alignIcon={'left'}>
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required>
                    Adicionar novo motivo
                  </Input.Label>
                  <Input.Prompt value={formContext} field={'newReason'} setValue={setFormContext}></Input.Prompt>
                </Input.Contents>
              </Input.Root>
            </Column.Content>
            <Column.Content size="is-2">
              <Button.Bt
                color="is-light"
                className="mt-5"
                action={() => {
                  addReason()
                }}
                loading={loading}
              >
                Adicionar
              </Button.Bt>
            </Column.Content>
          </Column.Root>
        )}

        <Column.Root className="">
          <Column.Content>
            <Input.Root>
              <Input.Contents alignIcon={'left'}>
                <Input.Prompt value={search} setValue={setSearch} placeholder="Pesquisar..."></Input.Prompt>
                <Input.Icon align="is-left">
                  <Icon size={20}>search</Icon>
                </Input.Icon>
              </Input.Contents>
            </Input.Root>
          </Column.Content>
        </Column.Root>

        <Column.Root className="">
          <Column.Content>
            <Table.Root className="is-fullwidth is-hoverable is-narrow has-text-centered ">
              <Table.Head>
                <Table.Row>
                  <Table.Cell>Motivo</Table.Cell>
                  <Table.Cell>Ações</Table.Cell>
                </Table.Row>
              </Table.Head>
              <Table.Body>
                {dataContextFiltered.map((value, index) => {
                  return (
                    <>
                      <Table.Row>
                        <Table.Cell className="is-size-7 is-vcentered">{value.label}</Table.Cell>
                        <Table.Cell className="is-vcentered">
                          <div style={{ marginTop: 5 }}>
                            <Button.Root align="centered">
                              <Button.Content>
                                <Button.Bt
                                  size="is-small"
                                  color="is-danger"
                                  action={() => {
                                    handleDeleteReason(value)
                                  }}
                                  loading={loading}
                                >
                                  <Icon size={15}>trash</Icon>
                                </Button.Bt>
                              </Button.Content>
                            </Button.Root>
                          </div>
                        </Table.Cell>
                      </Table.Row>
                    </>
                  )
                })}
              </Table.Body>
            </Table.Root>
          </Column.Content>
        </Column.Root>
      </Page.Root>
    </>
  )
}
